import { Component, Inject, Input, Optional } from '@angular/core';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { REQUEST } from '@nguniversal/express-engine/tokens';

@Component({
  selector: 'app-search-filter-item',
  templateUrl: './filter-item.component.html',
  styleUrls: ['./filter-item.component.scss'],
})
export class FilterItemComponent {
  constructor(@Optional() @Inject(REQUEST) private webAppBuyerRequest: any) {}
  @Input() count: number;
  @Input() itemValue: string;
  @Input() filters: any[];
  @Input() selected = false;
  @Input() extended: boolean;
  @Input() hideCount: boolean;
  country = getCountryDomainCode(this.webAppBuyerRequest);
}
